import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { fetchData, postData } from "../../services/apiServices";
import debounce from "lodash/debounce";

const AdminAccountData = () => {
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState("");
  const [userType, setUserType] = useState("all");
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    username: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);

  const openViewModal = (row) => {
    setSelectedAccount(row);
    setFormData(row);
    setViewModal(true);
  };
  const columns = [
    {
      name: "Account Name",
      selector: (row) => row.accountName,
      sortable: true,
    },
    {
      name: "Bank Name",
      selector: (row) => row.bankName,
      sortable: true,
    },
    {
      name: "Account Number",
      selector: (row) => row.accountNumber,
    },
    {
      name: "IFSC / SWIFT",
      selector: (row) => row.swiftIFSCCode,
    },
    {
      name: "UPI ID",
      selector: (row) => row.upiID || "-",
    },
    {
      name: "Type",
      selector: (row) => row.paymenttype,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`badge ${row.status === "active" ? "bg-success" : "bg-danger"}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <Button size="sm" color="info" onClick={() => openViewModal(row)}>
          View
        </Button>
      ),
    },
  ];
  const getData = async (page, searchQuery = "") => {
    setPending(true);
    try {
      // Pass search query as a parameter object
      const params = {
        page,
        limit: perPage,
        search: searchQuery,
      };

      const response = await fetchData("api/admin/getadminbankdetails", params);
      if (response && response.status && response.data) {
        let sortedData = response.data;
        if (searchQuery) {
          sortedData = sortedData.sort((a, b) => {
            const aUsername = (a.username || "").toLowerCase();
            const bUsername = (b.username || "").toLowerCase();
            const aEmail = (a.email || "").toLowerCase();
            const bEmail = (b.email || "").toLowerCase();
            const searchLower = searchQuery.toLowerCase();

            // Exact matches come first
            if (aUsername === searchLower || aEmail === searchLower) return -1;
            if (bUsername === searchLower || bEmail === searchLower) return 1;

            // Then starts with matches
            if (
              aUsername.startsWith(searchLower) ||
              aEmail.startsWith(searchLower)
            )
              return -1;
            if (
              bUsername.startsWith(searchLower) ||
              bEmail.startsWith(searchLower)
            )
              return 1;

            // Then includes matches
            const aIncludes =
              aUsername.includes(searchLower) || aEmail.includes(searchLower);
            const bIncludes =
              bUsername.includes(searchLower) || bEmail.includes(searchLower);
            if (aIncludes && !bIncludes) return -1;
            if (!aIncludes && bIncludes) return 1;

            return 0;
          });
        }

        setRows(sortedData);
        setTotalRows(
          response.pagination?.totalAccounts || response.data.length,
        );
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setRows([]);
      setTotalRows(0);
    } finally {
      setPending(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      getData(1, searchQuery);
      setCurrentPage(1);
    }, 300), // Reduced debounce time for better responsiveness
    [perPage],
  );

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    debouncedSearch(searchValue);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getData(page, search);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPending(true);
    setPerPage(newPerPage);
    try {
      const params = {
        page,
        limit: newPerPage,
        search,
      };
      const response = await fetchData("api/admin/getadminbankdetails", params);
      if (response && response.data) {
        setRows(response.data);
        setTotalRows(
          response.pagination?.totalAccounts || response.data.length,
        );
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getData(1, "");
  }, []);
  const handleUpdateAccount = async () => {
    try {
      setSaving(true);
      await postData("api/admin/updateadminbankdetails", {
        accountId: selectedAccount._id,
        ...formData,
      });
      setViewModal(false);
      getData(currentPage, search);
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex gap-3 align-items-center">
            {/* <Input
              type="select"
              value={userType}
              onChange={handleUserTypeChange}
              style={{ width: "150px" }}
            >
              <option value="all">All Users</option>
              <option value="internal">Internal</option>
              <option value="external">External</option>
            </Input> */}
          </div>
          {/* <Button color="primary" onClick={toggleModal}>
            Create User
          </Button> */}
        </div>

        <DataTable
          columns={columns}
          data={rows}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          progressPending={pending}
          responsive
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 30, 50, 100]}
        />
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
          <ModalHeader toggle={() => setViewModal(false)}>
            Admin Account Details
          </ModalHeader>
          <ModalBody>
            {formData && (
              <Row>
                <Col md={6}>
                  <Label>Account Name</Label>
                  <Input
                    value={formData.accountName || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, accountName: e.target.value })
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label>Bank Name</Label>
                  <Input
                    value={formData.bankName || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, bankName: e.target.value })
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label>Account Number</Label>
                  <Input
                    value={formData.accountNumber || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        accountNumber: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label>IFSC / SWIFT</Label>
                  <Input
                    value={formData.swiftIFSCCode || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        swiftIFSCCode: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label>UPI ID</Label>
                  <Input
                    value={formData.upiID || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, upiID: e.target.value })
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label>Status</Label>
                  <Input
                    type="select"
                    value={formData.status || "active"}
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Input>
                </Col>
              </Row>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={handleUpdateAccount}
              disabled={saving}
            >
              Save Changes
            </Button>
            <Button color="secondary" onClick={() => setViewModal(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>
    </Card>
  );
};

export { AdminAccountData };
